import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getAnalytics(params, signal) {
  return request({
    url: '/eventAnalytic',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}

export function getMaterialsAnalytics(params, signal) {
  return request({
    url: '/eventAnalytic/materials',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}
